import { useSelector } from "react-redux";
import { highlightNode } from "layouts/Flow Designer/helpers/common";
import { memo } from "react";
import { useReactFlow, getOutgoers } from "reactflow";
import { COMMON_COMPONENT_TYPES } from "constants/flowDesigner";
import { clearNodesHighlight } from "layouts/Flow Designer/helpers/common.js";

export const Highlighter = memo(() => {
  const { executionReports } = useSelector((store) => store.designer.flowExecution);
  const currentSavedFlow = useSelector((store) => store.designer.flows.currentSavedFlow);
  const reactFlowInstance = useReactFlow();
  const { getNode, getNodes, getEdges } = reactFlowInstance;
  const activeTab = useSelector((s) => s.designer.tabs.activeFlexLayoutTab);
  const isLogsTabActive = activeTab === "executionReport";

  if (!isLogsTabActive) {
    clearNodesHighlight();
    return null;
  }

  const filteredFlowReports = executionReports.filter(
    (report) => report.id === currentSavedFlow?.id
  );

  let reportToUse = null;

  if (filteredFlowReports.length === 1) {
    reportToUse = filteredFlowReports[0];
  } else {
    reportToUse = filteredFlowReports[filteredFlowReports.length - 1];
  }

  const getLabelNode = (nodes, label) => {
    return nodes.find((node) => node.data.label === label);
  };

  const highLightLabelNode = (data, node) => {
    const response = data?.response;

    if (!response || typeof response !== "object") return;

    const getOutgoer = getOutgoers(node, getNodes(), getEdges());

    if (Object.prototype.hasOwnProperty.call(response, "selection_branch_result")) {
      const outgoerNode = getLabelNode(getOutgoer, response.selection_branch_result);
      if (outgoerNode) {
        highlightNode(outgoerNode.id, data.remarks);
      }
    } else if (response.branches) {
      Object.keys(response.branches).forEach((branchKey) => {
        const branchResult = response.branches[branchKey]?.result;
        if (branchResult) {
          const outgoerNode = getLabelNode(getOutgoer, branchKey);
          if (outgoerNode) {
            highlightNode(outgoerNode.id, data.remarks);
          }
        }
      });
    }
  };

  if (reportToUse) {
    clearNodesHighlight();
    highlightNode("1", "Success");
    reportToUse.data.forEach((data) => {
      highlightNode(data.nodeId, data.remarks);

      const node = getNode(data.nodeId);
      if (
        node?.data?.type === COMMON_COMPONENT_TYPES.SELECTION ||
        node?.data?.type === COMMON_COMPONENT_TYPES.CONDITIONAL
      ) {
        highLightLabelNode(data, node);
      }
    });
    highlightNode("2", "Success");
  }
});
